import Vue, { computed } from "vue";
import Vuex from "vuex";

import "@js/constants.js";
import { CacheTool } from "@js/cache-tool.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // accountInfo: CacheTool.getAccountInfo(),
    accountInfo: undefined,
    isMainLeftSlim: false,
    selectedModuleIndex: 0,
    selectedHospital: { name: "全部", hospitalid: null },
    deviceInfo: undefined,
    loadingShow: false,

    // 简化：只保存搜索的SN（用于跨项目跳转）
    searchSN: null,
    
    // 设备类型（用于报告相关页面）
    deviceType: null
  },

  getters: {
    isSeniorAdministrator(state) {
      console.log('state',state)
      return state.accountInfo?.roleName == '高级系统管理员'
    },
    isLiBin(state){
      return state.accountInfo?.id == 2609||state.accountInfo?.id == 2887
    },

    isSalesManager(state){
      return state.accountInfo?.roleName == '销售经理'
    },

    isSeniorAdministratorOrOperationMember(state) {
      return state.accountInfo?.roleName == '高级系统管理员' || state.accountInfo?.roleName == '运营专员'
    },

    isSales(state) {
      return state.accountInfo?.roleId == 13; //销售
    },

    isOperationsSpecialist(state) {
      return state.accountInfo?.roleId == 8; //运营专员
    },

    deviceType(state) {
      return state.deviceType;
    }
  },

  mutations: {
    //isMainLeftSlim
    saveIsMainLeftSlim(state, isMainLeftSlim) {
      state.isMainLeftSlim = isMainLeftSlim;
      CacheTool.saveStoreState(state) //每次操作保存一下state备份。供App页面刷新时重新载入
    },

    //selectedModuleIndex
    saveSelectedModuleIndex(state, selectedModuleIndex) {
      state.selectedModuleIndex = selectedModuleIndex;
      CacheTool.saveStoreState(state)
    },

    //hospital
    saveSelectedHospital(state, selectedHospital) {
      state.selectedHospital = selectedHospital;
      CacheTool.saveStoreState(state)
    },

    //accountInfo
    saveAccountInfo(state, accountInfo) {
      state.accountInfo = accountInfo;
      CacheTool.saveStoreState(state)
    },

    removeAccountInfo(state) {
      state.accountInfo = undefined;
      CacheTool.saveStoreState(state)
    },

    //deviceInfo
    saveDeviceInfo(state, deviceModel) {
      state.deviceInfo = deviceModel;
      CacheTool.saveStoreState(state)
    },

    removeDeviceInfo(state) {
      state.deviceInfo = undefined;
      CacheTool.saveStoreState(state)
    },

    // 新增：保存搜索SN（跨项目跳转用）
    saveSearchSN(state, sn) {
      state.searchSN = sn;
      // 这里不需要持久化存储，因为是临时的跳转信息
    },

    // 新增：清除搜索SN
    clearSearchSN(state) {
      state.searchSN = null;
    },

    // 新增：保存设备类型
    saveDeviceType(state, deviceType) {
      state.deviceType = deviceType;
      // 这里不需要持久化存储，因为是临时的页面间传递信息
    },

    // 新增：清除设备类型
    clearDeviceType(state) {
      state.deviceType = null;
    }
  },
  actions: {},
  modules: {}
});